export default __webpack_public_path__ + "media/img_04/600@2x-4e87b47d.jpg";